module.exports = __webpack_public_path__ + "img/retail.0a1045bc.jpg";